// extracted by mini-css-extract-plugin
export var base = "_24-0";
export var updateBanner = "_24-1";